import HackleCore from "../../core/HackleCore"
import { User } from "../../core/internal/model/model"
import { UserListener } from "../../core/internal/user/UserListener"
import { UserManager } from "../../core/internal/user/UserManager"
import { PropertyOperations } from "../property/PropertyOperations"

/**
 * Tracks the `$properties` event when property operations are applied. Only the local user
 * manager fires `onPropertyOperations`; in remote evaluation the operations ride the evaluate
 * request instead of an event.
 */
export class PropertiesEventTracker implements UserListener {
  constructor(private readonly userManager: UserManager, private readonly core: HackleCore) {}

  onUserUpdated(_oldUser: User, _newUser: User, _timestamp: number): void {}

  onPropertyOperations(user: User, operations: PropertyOperations, timestamp: number): void {
    const event = operations.toEvent()
    const hackleUser = this.userManager.hackleUser(user)
    this.core.track(event, hackleUser, timestamp)
    this.core.flush(false)
  }
}
